import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './common/components/navigation/navigation';
import { HomeObserver } from './observers/home-observer';
import { TimerObserver } from './observers/timer-observer';
import { RulerObserver } from './observers/ruler-observer';
import { CalculatorObserver } from './observers/calculator-observer';
import { NotepadObserver } from './observers/notepad-observer';
import { UnitConverterObserver } from './observers/unit-converter-observer';
import { CurrencyConverterObserver } from './observers/currency-converter-observer';

export const App: React.FC = () => {
  return (
    <Router>
      <div className="app">
        <div className="app__header">
          <h1>General Tools</h1>
        </div>
        
        <Navigation />
        
        <main className="app__content">
          <Routes>
            <Route path="/" element={<HomeObserver />} />
            <Route path="/timer" element={<TimerObserver />} />
            <Route path="/ruler" element={<RulerObserver />} />
            <Route path="/calculator" element={<CalculatorObserver />} />
            <Route path="/notepad" element={<NotepadObserver />} />
            <Route path="/unit-converter" element={<UnitConverterObserver />} />
            <Route path="/currency-converter" element={<CurrencyConverterObserver />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};
